import { setState, setStateById } from './helpers'

const userMutations = {
  SET_USER_FILTERS: setState('userFilters'),
  SET_FILTERS_USER: setState('filterUsers'),

  SET_CUSTOMER: setState('customer'),
  SET_USER(state, payload) {
    state.user = payload.data
  },
  SET_USER_MODEL: setState('userModel'),
  REMOVE_USER_STAFF_CONNECTION(state, staffId) {
    const salespersonsDealers = Array.isArray(state.userModel?.salespersons_dealers)
      ? state.userModel.salespersons_dealers.filter((sales) => String(sales.id) !== String(staffId))
      : []

    state.userModel = {
      ...state.userModel,
      salespersons_dealers: salespersonsDealers,
    }
  },
  ADD_USER_STAFF_CONNECTION(state, staff) {
    const salespersonsDealers = Array.isArray(state.userModel?.salespersons_dealers)
      ? state.userModel.salespersons_dealers
      : []

    const isDuplicate = salespersonsDealers.some((sales) => {
      if (staff?.id != null && sales.id != null && String(sales.id) === String(staff.id)) {
        return true
      }

      const staffUserId = staff?.sales_person_id ?? staff?.hashid
      const salesUserId = sales?.sales_person_id ?? sales?.hashid

      return staffUserId != null && salesUserId != null && String(staffUserId) === String(salesUserId)
    })

    if (isDuplicate) {
      return
    }

    state.userModel = {
      ...state.userModel,
      salespersons_dealers: [...salespersonsDealers, staff],
    }
  },
  SET_USER_ADMIN: setState('user_admin'),
  CLEAR_AUTH_SESSION(state) {
    state.user = {}
    state.user_admin = {}
    state.admin_role = []
    state.userPermissions = []
    state.availableModules = []
    state.tenantModules = {}
    state.modulesBySlug = {}
    state.tenantConfig = {}
  },
  SET_USERS: setState('users'),
  SET_LANGS: setState('langs'),
  SET_STAFFS: setState('staffs'),

  SET_ATTRIBUTES: setState('attributes'),
  SET_ATTRIBUTE: setState('attribute'),
  SET_ATTRIBUTES_SELECT: setState('attributesSelect'),
  SET_ATTRIBUTE_MODEL: setState('attributesModel'),

  SET_OPTIONS: setState('options'),
  SET_OPTION: setState('option'),
  SET_OPTIONS_SELECT: setState('optionsSelect'),
  SET_OPTIONS_MODEL: setState('optionsModel'),

  SET_VENDORS: setState('vendors'),
  SET_VENDORS_SELECT: setState('vendorsSelect'),
  SET_SUPPLIERS: setState('suppliers'),
  SET_SUPPLIERS_SELECT: setState('suppliersSelect'),

  SET_ADDRESS_STREET: setStateById('addressStreet'),
  SET_ADDRESS_CITY: setStateById('addressCity'),

  SET_DEALERS: setState('dealers'),
  SET_WHOLESALERS: setState('wholesalers'),

  SET_USER_ORDERS: setState('userOrders'),
  SET_BANK_STATEMENT: setState('bankStatement'),
  SET_LOGIN_HISTORY: setState('loginHistory'),
  SET_LOGINS_HISTORY: setState('loginsHistory'),
  SET_DELETED_USERS: setState('detetedUsers'),

  SET_INACTIVE_USERS: setState('inactiveUsers'),
  SET_CS_NUMBERS_TO_APPROVE: setState('csNumberToApprove'),
  SET_MESSAGE_STATUS_MATCH: setState('messageIbanStatus'),
  SET_STATUS_MATCH: setState('csNumberToApprove'),

  SET_ADMIN_ROLE: setState('admin_role'),

  SET_ACTIVITIES: setState('activities'),
  SET_ACTIVITIES_GLOBAL: setState('activitiesGlobal'),
  SET_ACTIVITY_FILTERS: setState('activityFilters'),

  SET_USER_APPS: setState('userApps'),
  SET_INITIAL_USER_ROLE: setState('initialUserRole'),

  SET_USERS_PENDING: setState('usersPending'),

  SET_MENU_FILTERS: setState('menuList')
}

export { userMutations }
